import { generateRedirectGuard } from "./_shared/guards/redirect-guard.guard";
import { RouteWithPaths } from "./_shared/models/route-with-paths";
import { createRoutePath } from "./_shared/utils/route-util";
import { DummyPageComponent } from "./_template/pages/dummy-page/dummy-page.component";
import accountingRoutes from "./accounting/accounting-routes";
import activityRoutes from "./activity/activity-routes";
import addressRoutes, { AddressPaths } from "./address/address-routes";
import communicationRoutes from "./communication/communication-routes";
import contactsRoutes from "./contacts/contacts-routes";
import dashboardRoutes, { DashboardPaths } from "./dashboard/dashboard-routes";
import documentsRoutes from "./documents/documents-routes";
import expensesRoutes from "./expenses/expenses-routes";
import federationRoutes from "./federation/federation-routes";
import formsRoutes from "./forms/forms-routes";
import jobsRoutes from "./jobs/jobs-routes";
import meetingsRoutes from "./meetings/meetings-routes";
import membersRoutes from "./members/members-routes";
import organisationRoutes, { OrganizationPaths } from "./organisation/organisation-routes";
import personRoutes from "./person/person-routes";
import productRoutes from "./product/product.routes";
import settingsRoutes from "./settings/settings-routes";
import tasksRoutes from "./tasks/tasks-routes";
import volunteersRoutes from "./volunteers/volunteers-routes";
import vwijzerRoutes from "./vwijzer/vwijzer-routes";
import vzwHelperRoutes from "./vzw-helper/vzw-helper-routes";
import vrijwilligerswerkRoutes from "./weldoeners/vrijwilligerswerk-routes";
import weldoenersRoutes from "./weldoeners/weldoeners-routes";
import widgetsRoutes from "./widgets/widgets-routes";

export const AppPaths = {
  Addresses: "adressen",
  Organization: "organisatie",
  Dashboard: "welkom",
  Volunteers: "vrijwilligers",
  Jobs: "vacatures",
  Contacts: "contacten",
  Accounting: "boekhouding",
  Widgets: "widgets",
  Persons: "personen",
  Settings: "instellingen",
  Activities: "activiteiten",
  Tasks: "taken",
  Expenses: "kosten",
  Communication: "communicatie",
  Members: "leden",
  Weldoeners: "weldoeners",
  Vrijwilligerswerk: "vrijwilligerswerk",
  Forms: "formulieren",
  Documents: "documenten",
  Meetings: "gesprekken",
  Federation: "federatie",
  VzwHelper: "vzw-helper",
  VWijzer: "v-wijzer",
  ResetLocalStorage: "error-oplosser",
  Products: "producten",
};

export default [
  {
    path: "",
    redirectTo: createRoutePath(AppPaths.Dashboard),
    pathMatch: "full",
  },
  {
    path: "home",
    redirectTo: createRoutePath(AppPaths.Dashboard),
  },
  {
    path: AppPaths.Dashboard,
    data: { breadcrumb: "Dashboard" },
    children: dashboardRoutes,
    paths: DashboardPaths,
  },
  {
    path: AppPaths.Organization,
    data: { breadcrumb: "Organisatie" },
    children: organisationRoutes,
    paths: OrganizationPaths,
  },
  {
    path: AppPaths.Volunteers,
    data: { breadcrumb: "Vrijwilligers" },
    children: volunteersRoutes,
  },
  {
    path: "volunteers",
    canActivate: [generateRedirectGuard(AppPaths.Volunteers)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "volunteers/**",
    canActivate: [generateRedirectGuard(AppPaths.Volunteers)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "volunteers/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Volunteers)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Jobs,
    data: { breadcrumb: "Vacatures" },
    children: jobsRoutes,
  },
  {
    path: "jobs/**",
    canActivate: [generateRedirectGuard(AppPaths.Jobs)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "jobs/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Jobs)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Contacts,
    data: { breadcrumb: "Contacten" },
    children: contactsRoutes,
  },
  {
    path: "contacts/**",
    canActivate: [generateRedirectGuard(AppPaths.Contacts)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "contacts/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Contacts)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Accounting,
    data: { breadcrumb: "Boekhouding" },
    children: accountingRoutes,
  },
  {
    path: "accounting/**",
    canActivate: [generateRedirectGuard(AppPaths.Accounting)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "accounting/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Accounting)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Widgets,
    data: { breadcrumb: "Widgets" },
    children: widgetsRoutes,
  },
  {
    path: AppPaths.Persons,
    data: { breadcrumb: "Personen" },
    children: personRoutes,
  },
  {
    path: "person/**",
    canActivate: [generateRedirectGuard(AppPaths.Persons)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "person/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Persons)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Addresses,
    data: { breadcrumb: "Organisaties" },
    paths: AddressPaths,
    children: addressRoutes,
  },
  {
    path: "address",
    redirectTo: AppPaths.Addresses,
  },
  {
    path: "address/**",
    canActivate: [generateRedirectGuard(AppPaths.Addresses)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "address/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Addresses)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Settings,
    data: { breadcrumb: "Voorkeuren en instellingen" },
    children: settingsRoutes,
  },
  {
    path: "settings",
    redirectTo: AppPaths.Settings,
  },
  {
    path: "settings/**",
    canActivate: [generateRedirectGuard(AppPaths.Settings)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "settings/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Settings)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Activities,
    data: { breadcrumb: "Activiteiten" },
    children: activityRoutes,
  },
  {
    path: "activity",
    redirectTo: AppPaths.Activities,
  },
  {
    path: "activity/**",
    canActivate: [generateRedirectGuard(AppPaths.Activities)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "activity/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Activities)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Expenses,
    data: { breadcrumb: "Kosten" },
    children: expensesRoutes,
  },
  {
    path: "expenses",
    redirectTo: AppPaths.Expenses,
  },
  {
    path: "expenses/**",
    canActivate: [generateRedirectGuard(AppPaths.Expenses)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "expenses/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Expenses)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Tasks,
    data: { breadcrumb: "Taken en interesses" },
    children: tasksRoutes,
  },
  {
    path: AppPaths.Communication,
    data: { breadcrumb: "Communicatie" },
    children: communicationRoutes,
  },
  {
    path: "communication",
    redirectTo: AppPaths.Communication,
  },
  {
    path: "communication/**",
    canActivate: [generateRedirectGuard(AppPaths.Communication)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: "communication/:subpath",
    canActivate: [generateRedirectGuard(AppPaths.Communication)],
    component: DummyPageComponent,
    pathMatch: "prefix",
  },
  {
    path: AppPaths.Weldoeners,
    data: { breadcrumb: "Wéldoeners" },
    children: weldoenersRoutes,
  },
  {
    path: AppPaths.Vrijwilligerswerk,
    data: { breadcrumb: "Vrijwilligerswerk.be" },
    children: vrijwilligerswerkRoutes,
  },
  {
    path: AppPaths.VzwHelper,
    data: { breadcrumb: "Vzw-Helper" },
    children: vzwHelperRoutes,
  },
  {
    path: AppPaths.VWijzer,
    data: { breadcrumb: "V-Wijzer" },
    children: vwijzerRoutes,
  },
  {
    path: AppPaths.Members,
    data: { breadcrumb: "Leden" },
    children: membersRoutes,
  },
  {
    path: AppPaths.Forms,
    data: { breadcrumb: "Formulieren" },
    children: formsRoutes,
  },
  {
    path: AppPaths.Federation,
    data: { breadcrumb: "Federatie" },
    children: federationRoutes,
  },
  {
    path: AppPaths.Documents,
    data: { breadcrumb: "Documenten" },
    children: documentsRoutes,
  },
  {
    path: AppPaths.Meetings,
    data: { breadcrumb: "Gesprekken" },
    children: meetingsRoutes,
  },
  {
    path: AppPaths.Products,
    data: { breadcrumb: "Producten" },
    children: productRoutes,
  },
  {
    path: AppPaths.ResetLocalStorage,
    loadComponent: () =>
      import("./public/pages/local-storage-reset/local-storage-reset.component").then(
        (c) => c.LocalStorageResetComponent
      ),
  },

  {
    path: "**",
    loadComponent: () =>
      import("./_shared/components/not-found/not-found.component").then((c) => c.NotFoundComponent),
    data: {
      title: "Oeps... deze pagina is verdwenen",
      breadcrumb: "Pagina verdwenen",
    },
  },
  /*{
    path: "**",
    redirectTo: "niet-gevonden",
  },*/
] satisfies RouteWithPaths[];
